var checkboxes = require('../../lib/checkboxes.js');
var Regions = require('../../lib/regions.js');

module.exports = function() {
  new Regions($('.countries'));
};

checkboxes.conditionalEnable('#vat', '#exempt-from-vat');
